// TODO: remove websdk

import Services from "./wagmi";
import { ReactNode } from "react";
import { useUtmRefereal } from "@hooks/useUtm";

const SDKProvider = ({ children }: { children: ReactNode }) => {
  useUtmRefereal();

  return <Services>{children}</Services>;
};

export default SDKProvider;
